import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import NotificationsAPI from '../../../../utils/api/notificationsAPI';

const entity = new ReduxRestEntity({
  name: 'notifications',
  api: NotificationsAPI(),
});

export default entity;
